module.exports = __webpack_public_path__ + "img/427.74910904.png";